import React from 'react'; 

function TableErrorMessage() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: '5rem',
      color: 'red', // optional for error color
      textAlign: 'center'
    }}>
      <p>Please select at least one column to display the table data.</p>
    </div>
  );
}

export default TableErrorMessage;